import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@zaogig/auth';
import type { Job, PaginatedResponse } from '@zaogig/types';

export function useJobs(params?: Record<string, string>) {
  return useQuery({
    queryKey: ['jobs', params],
    queryFn: () => apiClient.get<PaginatedResponse<Job>>('/v1/jobs', params),
  });
}

export function useJobDetail(id: string) {
  return useQuery({
    queryKey: ['job', id],
    queryFn: () => apiClient.get<Job>('/v1/jobs/' + id),
    enabled: !!id,
  });
}

export function useApplyJob() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, ...body }: { jobId: string; expectedSalary?: number; coverLetter?: string }) =>
      apiClient.post('/v1/jobs/' + jobId + '/apply', body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
  });
}

export const useJobList = useJobs;
export { useJobDetail as useJob };
export { useApplyJob as useApply };
